module.exports = __webpack_public_path__ + "img/weixinorder.658419f4.png";